import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { SalesFileService } from '../../services/sales-file.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { DisplayModes } from '../../../models/enums';
import { UsersApiService } from '../../../services/users-api.service';


@Component({
  selector: 'crm-edit-user-target-request-approval-users',
  templateUrl: './edit-user-target-request-approval-users.component.html',
  styleUrls: ['./edit-user-target-request-approval-users.component.css']
})
export class EditUserTargetRequestApprovalUsersComponent implements OnInit {
  @Input() selectedLevel: any;
  @Output() closeEvent = new EventEmitter<boolean>();
  displayMode: DisplayModes;
  users: any[] = [];

  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'fullName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  constructor(private translateService: AppTranslationService, private alertService: AlertService,
    private salesFileService: SalesFileService, private usersService: UsersApiService) { }


  ngOnInit() {
    this.selectedLevel.typeName = this.getTypeName(this.selectedLevel.type);
    this.getUsers();
  }

  getUsers() {
    this.usersService.getAllUsersMini().subscribe(response => {
      this.displayMode = DisplayModes.Success
      this.users = response as any[];
      if (this.users && this.selectedLevel.usersIds) {
        this.selectedLevel.users = this.users.filter(u => this.selectedLevel.usersIds.includes(u.id));
      }
    }, error => {
      console.log(error);
    });
  }

  save(f) {
    this.displayMode = DisplayModes.Loading;
    if (this.selectedLevel.users != null) {
      this.selectedLevel.usersIds = this.selectedLevel.users.map(u => u.id);
    }

    this.salesFileService.saveUserTargerRequestApprovalUsers(this.selectedLevel).subscribe(() => {
      this.alertService.stopLoadingMessage();
      this.displayMode = DisplayModes.Success;
      this.closeEvent.emit(true);
      this.alertService.showMessage("", this.translateService.getTranslation("SavedSuccessfully"), MessageSeverity.Success);
    }, () => {
      this.alertService.stopLoadingMessage();
      this.displayMode = DisplayModes.Error;
    });
  }

  back() {
    this.closeEvent.emit(true);
  }

  onItemSelect(item: any) {
    console.log(item);
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  getTypeName(type: number): string {
    if (type == 1)
      return "Brand"
    if (type == 2)
      return "Item and parent org type"
    if (type == 3)
      return "Item and child org type"
    if (type == 4)
      return "Item and Hco"
  }

}
